import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminatorUpdateAction from './inseminatorUpdate.action.json' with { type: 'json' }
import { inseminatorObject } from '../inseminatorObject'

const inseminatorUpdateDefinition = defineAction({
  ...inseminatorUpdateAction,

  input: inseminatorObject.partial().required({ id: true }),
  output: z.object({}),
})

export default inseminatorUpdateDefinition
